import { MulticastIcon } from './MulticastIcon';

/**
 * author: Simran
 * id 8D4D600F-56EB-488D-992A-24B393EE6D47
 * name multicast
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/multicast.svg
 * tags
 */
export const MultiplexIcon = MulticastIcon;
export default MultiplexIcon